var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.survey)?_c('v-sheet',{directives:[{name:"",rawName:"v-"}],staticClass:"pa-5 mw-survey rounded-lg",attrs:{"flat":"","color":"lightest"}},[_c('survey-inner',{attrs:{"id":_vm.id,"disable":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }